import React from 'react';
import useTranslation from 'next-translate/useTranslation';

import { ForgotPassword } from '~/domains/auth/components/ForgotPassword';

function ForgotPasswordPage() {
  const { t } = useTranslation('auth');
  return (
    <ForgotPassword
      title={t('forgotPassword.title')}
      subtitle={t('forgotPassword.subtitle')}
      heading={t('forgotPassword.heading')}
    />
  );
}

export default ForgotPasswordPage;

ForgotPasswordPage.isPublic = true;
